import {
	Component, OnInit, AfterContentInit, ViewChild,
	ElementRef, Input, ContentChildren, QueryList, Output, EventEmitter
} from '@angular/core';
import { IconButtonComponent } from '../icon-button/icon-button.component';

import { StatefulCSS } from 'src/app/model/stateful_css';
import { ActionGroupEvent } from 'src/app/types/actiongroupevent';
import { ToggleGroup } from 'src/app/model/toggle-group';
import { ButtonService } from 'src/app/services/button.service';
import { isNgTemplate } from '@angular/compiler';


@Component({
	selector: 'app-action-group',
	templateUrl: './action-group.component.html',
	styleUrls: ['./action-group.component.scss']
})
export class ActionGroupComponent implements OnInit, AfterContentInit {

	@ViewChild('title', { static: true }) title: ElementRef;
	@ViewChild('container', { static: true }) container: ElementRef;
	@ViewChild('inputs', { static: true }) inputs: ElementRef;

	@ContentChildren(IconButtonComponent, { descendants: true }) buttons !: QueryList<IconButtonComponent>;
	@Input() name: string;

	@Output() actions: EventEmitter<ActionGroupEvent>;

	protected isActive = false;
	protected viewStates: StatefulCSS;
	protected group: string;
	protected toggleGroups: any = {};
	protected visCount = 0;

	constructor(private node: ElementRef, private buttonService: ButtonService) { }
	get domNode(): ElementRef {
		return this.node;
	}
	get viewState(): string {
		return this.viewStates.GetCurrentState();
	}

	ngOnInit() {
		this.group = '';
		this.viewStates = new StatefulCSS();
		this.viewStates.SetPrefix('action-display');
		this.viewStates.SetMachine(this.container.nativeElement);
		this.viewStates.AddState('all');
		this.viewStates.AddState('group');
		this.viewStates.AddState('group-hidden');
		this.viewStates.SetState('all');

		this.actions = new EventEmitter();
		if (this.name === '') {
			this.title.nativeElement.className = 'hidden';
		}
	}
	ngAfterContentInit() {
		// $(this.title.nativeElement).toggleClass('group-' + this.visCount, true);

		this.buttons.forEach((item: IconButtonComponent) => {
			/* item.isHiddenChange.subscribe(() => {
				this.UpdateTitle();
			});
			*/
			if (item.toggleGroup) {
				if (!this.toggleGroups.hasOwnProperty(item.toggleGroup)) {
					this.toggleGroups[item.toggleGroup] = new ToggleGroup();
				}
				(this.toggleGroups[item.toggleGroup] as ToggleGroup).AddButton(item, this.buttonService, this);
			}
			$(item.btn.nativeElement).on('mouseover', () => {
				if (this.name === '') {
					$(this.title.nativeElement).toggleClass('hidden', true);
					return;
				}
				if (item.group === 'tool') {
					$(this.title.nativeElement).toggleClass('hidden', true);
					return;
				}
				$(this.title.nativeElement).toggleClass('hidden', false);
			});
			$(item.btn.nativeElement).on('mouseout', () => {
				$(this.title.nativeElement).toggleClass('hidden', true);
			});
			item.btn.nativeElement.addEventListener('click', () => {
				const element: JQuery<any> = $(item.btn.nativeElement);
				if (element.hasClass('double-clicked')) {
					return;
				}
				if (element.hasClass('clicked')) {
					element.removeClass('clicked');
					element.addClass('double-clicked');
				} else {
					element.addClass('clicked');
					setTimeout(() => {
						if (element.hasClass('double-clicked')) {
							element.removeClass('double-clicked');
							this.HandleDoubleAction(item);
							return;
						}
						if (element.hasClass('clicked')) {
							element.removeClass('clicked');
							this.HandleActionButton(item);

						}
					}, 333);
				}

			});
			if (item.group) {
				this.group = item.group;
				this.viewStates.SetState('group');
				item.ToggleClass('groupee', false);

			}
			if (item.grouping) {
				item.ToggleClass('groupee', true);
				this.UpdateTitle();
			}
		});

	}
	HandleActionButton(button: IconButtonComponent) {
		if (button.menu) {
			$(button.element).siblings('.' + button.menu).toggleClass('hidden');
		}
		if (button.group === this.group) {
			this.viewStates.SetState((this.viewStates.GetCurrentState() === 'group') ? 'group-hidden' : 'group');
		} else if (button.grouping === this.group) {
			this.buttons.forEach((item: IconButtonComponent) => {
				if (item.grouping === this.group) {
					item.ToggleClass('selected', item.title === button.title);
				}
			});
		}
		this.actions.emit({ group: this, action: button.function, selected: button.IsSelected() });


	}
	HandleDoubleAction(button: IconButtonComponent) {
		if (button.HasDoubleFunction() !== false) {
			this.actions.emit({ group: this, action: button.dblfunction, selected: button.IsSelected() });
		} else {
			this.HandleActionButton(button);
		}
	}

	UpdateWidth() {
		$(this.title.nativeElement).width(this.inputs.nativeElement.offsetWidth);
	}
	ToggleActive(isActive: boolean = null) {
		if (isActive === null) {
			this.isActive = !this.isActive;
		} else {
			this.isActive = isActive;
		}
		$(this.domNode.nativeElement).toggleClass('active', this.isActive);
		$(this.domNode.nativeElement).toggleClass('sub-active', !this.isActive);
		this.UpdateTitle();

	}
	SetFirst() {
		this.HandleActionButton(this.buttons.toArray()[1]);
	}
	ToggleClass(className, onOff: boolean = true) {
		$(this.domNode.nativeElement).toggleClass(className, onOff);
		this.UpdateTitle();

	}
	Toggle() {
		if (this.viewStates.GetCurrentState() === 'group-hidden') {
			this.viewStates.SetState('group');

		} else {
			this.viewStates.SetState('group-hidden');
		}


	}
	SetSelected(buttonName, isSelected: boolean): void {
		const button: IconButtonComponent | null = this.GetButton(buttonName);
		if (button === null) { return; }
		if (!!button.toggleGroup) {
			this.buttons.forEach((item: IconButtonComponent) => {

				if (item.toggleGroup === button.toggleGroup) {
					item.ToggleClass('selected', (item.title.toLowerCase() === buttonName.toLowerCase()));
					item.Toggle(item.title.toLowerCase() === buttonName.toLowerCase());
				}

			});
			if (!isSelected) {
				button.Toggle(false);
			}
		} else {
			button.Toggle(isSelected);
		}

	}
	GetToggleGroup(groupName: string) {
		const buttons: Array<IconButtonComponent> = [];
		this.buttons.forEach((item: IconButtonComponent) => {
			if (item.toggleGroup === groupName) {
				buttons.push(item);
			}
		});
		return buttons;
	}
	GetSelected(): IconButtonComponent | null {
		let button: IconButtonComponent | null = null;
		this.buttons.forEach((item: IconButtonComponent) => {
			if (item.IsSelected()) {
				button = item;
			}
		});
		return button;
	}
	GetButton(title: string): IconButtonComponent | null {
		let result = null;
		this.buttons.forEach((item: IconButtonComponent) => {
			if (item.title.toLowerCase() === title.toLowerCase()) {
				result = item;
			}
		});
		return result;
	}
	UpdateTitle() {
		setTimeout(() => {
			this.UpdateWidth();
		}, 50);
	}

}
